


























































import Vue from 'vue';
import Popover from '../../../common/Popover.vue';
import TextArea from '../../../common/form/TextArea.vue';
import FileUpload from '../../../common/form/FileUpload.vue';
import PrimaryButton from '../../../common/buttons/PrimaryButton.vue';
import SecondaryButton from '../../../common/buttons/SecondaryButton.vue';
import FormInput from '../../../common/form/FormInput.vue';
import { createNamespacedHelpers, mapActions as mapRootActions } from 'vuex';
import Errors from '../../../common/form/Errors.vue';
import { mapState as mapRootState } from 'vuex';
const { mapActions, mapGetters, mapState, mapMutations } = createNamespacedHelpers('followUpForm');
const mapCustomLabelsState = createNamespacedHelpers('customLabels').mapState;
export default Vue.extend({
    components: {
        Errors,
        FormInput,
        SecondaryButton,
        PrimaryButton,
        FileUpload,
        TextArea,
        Popover,
    },
    computed: {
        ...mapRootState(['instanceId']),
        ...mapCustomLabelsState(['addFollowUpModalInfo', 'grievanceDescriptionPlaceholder']),
        ...mapGetters(['getFieldErrors', 'isFormValid']),
        ...mapState(['description', 'isSaving', 'documents', 'isUploading']),
    },
    methods: {
        ...mapMutations(['setDescription', 'resetForm', 'setDocuments', 'setIsUploading']),
        ...mapActions(['addFollowUp']),
        ...mapRootActions(['addError']),
        handleError(error: Error) {
            this.addError({ error });
        },
        async submit(hide: () => void) {
            await this.addFollowUp();
            if (!this.isFormValid) {
                return;
            }
            await this.resetForm();
            hide();
        },
        onHide() {
            this.setDescription({ description: '' });
            this.setDocuments({ documents: [] });
        },
    },
});
